import React, { FC } from "react";

const CSSolidLineComponent: FC = (props: any) => {
    return (
        <div
            className={`tw-ml-5 tw-mt-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200`}
        />
    );
};

export default CSSolidLineComponent;
